import React, {Fragment, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import * as actions from './authActions';
import styled from 'styled-components';
import LoginFormContainer from './LoginForm/LoginFormContainer';
import CheckEmailFormContainer from './CheckEmailForm/CheckEmailFormContainer';
import RegistrationContainer from '../Registration/RegistrationContainer';
import ConfirmCloseModal from './ConfirmCloseModal/ConfirmCloseModal';

const styles = () => ({
  scrollPaper: {
    alignItems:
      typeof window !== 'undefined' && window.innerWidth < 786
        ? 'flex-end'
        : 'center',
  },
  paper: {
    margin: 0,
    maxWidth: '100%',
    // maxHeight: '95%',
  },
});

const Wrapper = styled.div`
  width: 400px;
  padding: 20px;
  background: white;
  margin: auto;
  @media (max-width: 786px) {
    padding: 24px 20px;
    width: 100%;
  }
`;

const AuthContainer = ({
  authReducer,
  authenticationModalIsVisible,
  hideAuthenticationModal,
  resetCheckedEmail,
  classes,
  updatePhoneNumber,
  resetAuthReducer,
}) => {
  const {
    emailIsAvailable,
    emailHasBeenChecked,
    emailIsUnconfirmed,
  } = authReducer;

  useEffect(
    () => {
      if (!authenticationModalIsVisible) {
        resetAuthReducer();
        resetCheckedEmail();
      }
    },
    [authenticationModalIsVisible]
  );

  const [confirmCloseModalIsVisible, setConfirmCloseModalIsVisible] = useState(
    false
  );

  const handleConfirmModalConfirmClick = () => {
    setConfirmCloseModalIsVisible(false);
    hideAuthenticationModal();
  };

  const handleConfirmModalCancelClick = () => {
    setConfirmCloseModalIsVisible(false);
  };

  return (
    <Dialog
      id="Auth-AuthContainer-Dialog"
      aria-labelledby="payment-methods"
      aria-describedby="payment-methods"
      open={authenticationModalIsVisible}
      onBackdropClick={() => setConfirmCloseModalIsVisible(true)}
      fullWidth={typeof window !== 'undefined' && window.innerWidth < 786}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      classes={{scrollPaper: classes.scrollPaper}}
      PaperProps={{classes: {root: classes.paper}}}
      scroll="body"
    >
      <Wrapper>
        {emailHasBeenChecked ? (
          <Fragment>
            {emailIsAvailable || emailIsUnconfirmed ? (
              <RegistrationContainer
                id="Auth-AuthContainer-RegistrationContainer"
                hideAuthenticationModal={hideAuthenticationModal}
                resetCheckedEmail={resetCheckedEmail}
                updatePhoneNumber={updatePhoneNumber}
              />
            ) : (
              <LoginFormContainer
                id="Auth-AuthContainer-LoginFormContainer"
                hideAuthenticationModal={hideAuthenticationModal}
              />
            )}
          </Fragment>
        ) : (
          <CheckEmailFormContainer
            id="Auth-AuthContainer-EmailFormContainer"
            hideAuthenticationModal={hideAuthenticationModal}
          />
        )}
      </Wrapper>

      <ConfirmCloseModal
        id="Auth-AuthContainer-ConfirmCloseModal"
        handleConfirmClick={handleConfirmModalConfirmClick}
        handleCancelClick={handleConfirmModalCancelClick}
        confirmCloseModalIsVisible={confirmCloseModalIsVisible}
      />
    </Dialog>
  );
};

const mapStateToProps = state => ({
  authReducer: state.authReducer,
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    actions
  )(AuthContainer)
);
